export default __webpack_public_path__ + "static/media/rss2.0be4abf9.PNG";